(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7211,6552],{

/***/ 62320:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lottery",
      function () {
        return __webpack_require__(30084);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_sticky_box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42836);
/* harmony import */ var src_components_cards_card_h__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9789);
/* harmony import */ var src_components_cards_card_v__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40166);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75519);
/* harmony import */ var src_components_widgets_widget_lotto_check__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62755);
/* harmony import */ var src_components_widgets_widget_lotto_result__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33208);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25935);
/* harmony import */ var src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(32668);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2962);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88518);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31788);
/* harmony import */ var src_2_0_widgets_widget_breadcrumb__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36552);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38864);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84233);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34892);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25283);
/* harmony import */ var src_utils_services__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73113);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(51148);
/* harmony import */ var src_2_0_widgets_widget_heading__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(2657);








// import MobileDetect from 'mobile-detect';





// import SectionFullH from 'src/components/sections/section-full-h';

















var PageLottery = function(param) {
    var articles = param.articles, nextArticles = param.nextArticles, lastNews = param.lastNews, meta = param.meta, dataAdsHeader = param.dataAdsHeader;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_18__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    // console.log(articles);
    if (articles === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_14__["default"], {
            dataAdsHeader: dataAdsHeader,
            sessionSevId: sessionSevId
        });
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    var nextLinkRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(nextArticles === null || nextArticles === void 0 ? void 0 : nextArticles.next);
    var listArticlesRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(articles);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(articles), listArticles = ref[0], setListArticles = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFetching = ref1[0], setIsFetching = ref1[1];
    var handleScroll = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0,src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_26__/* .isShouldFetch */ .ie)()) return [
                            3,
                            2
                        ];
                        document.removeEventListener("scroll", handleScroll);
                        return [
                            4,
                            loadMoreArticles()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScroll() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadMoreArticles = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function() {
            var resData, ref, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            6,
                            7
                        ]);
                        if (!((nextArticles === null || nextArticles === void 0 ? void 0 : nextArticles.next) !== null)) return [
                            3,
                            4
                        ];
                        setIsFetching(true);
                        return [
                            4,
                            (0,src_utils_services__WEBPACK_IMPORTED_MODULE_21__/* .GET */ .H)("".concat(nextLinkRef === null || nextLinkRef === void 0 ? void 0 : nextLinkRef.current), false, true)
                        ];
                    case 1:
                        resData = _state.sent();
                        if (!!lodash__WEBPACK_IMPORTED_MODULE_9___default().isEmpty(resData === null || resData === void 0 ? void 0 : resData.data)) return [
                            3,
                            4
                        ];
                        nextLinkRef.current = resData === null || resData === void 0 ? void 0 : (ref = resData.links) === null || ref === void 0 ? void 0 : ref.next;
                        listArticlesRef.current = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(listArticlesRef.current).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(resData === null || resData === void 0 ? void 0 : resData.data));
                        setListArticles(listArticlesRef.current);
                        if (!(0,src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_26__/* .isShouldFetch */ .ie)()) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            loadMoreArticles()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        document.addEventListener("scroll", handleScroll);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("==========> LOAD_MORE ERROR", error.message);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsFetching(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMoreArticles() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("scroll", handleScroll);
        return function() {
            return document.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var baseUrlCategory = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_URL */ .FX, "/lottery}");
    var _article = {
        title: meta === null || meta === void 0 ? void 0 : meta.title,
        description: meta === null || meta === void 0 ? void 0 : meta.description,
        keyword: meta === null || meta === void 0 ? void 0 : meta.keyword
    };
    // const titlePage = 'สลากกินแบ่งรัฐบาล';
    // const articleTitle = escapeChar(meta.title);
    // const articleDescription = escapeChar(meta.abstract);
    // const { cid } = router.query;
    // console.log(category, subCategory);
    // console.log(nextLinkRef);
    // const titleEscape = escapeChar(meta.title);
    // console.log(articles);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_10__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z), {
                title: _article === null || _article === void 0 ? void 0 : _article.title,
                description: _article === null || _article === void 0 ? void 0 : _article.description,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                },
                openGraph: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_11__/* ["default"].openGraph */ .Z.openGraph), {
                    title: _article === null || _article === void 0 ? void 0 : _article.title,
                    description: _article === null || _article === void 0 ? void 0 : _article.description,
                    url: baseUrlCategory
                }),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: _article === null || _article === void 0 ? void 0 : _article.keyword
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_12___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: baseUrlCategory
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:title",
                        content: (_article === null || _article === void 0 ? void 0 : _article.title) || src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_TITLE */ .qN
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:description",
                        content: (_article === null || _article === void 0 ? void 0 : _article.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_DESC */ .a0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .IMAGE_DEFAULT */ .TH
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_20__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_9___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_20__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_9___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                 __th_page="lottery";\n            '
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "https://schema.org",\n                "@type": "WebSite",\n                "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_NAME */ .Ey, '",\n                "url": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.WEB */ .h$.WEB, '",\n                "description": "').concat((_article === null || _article === void 0 ? void 0 : _article.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_DESC */ .a0, '",\n                "sameAs": [\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.TWITTER */ .h$.TWITTER, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.YOUTUBE */ .h$.YOUTUBE, '",\n                  "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.LINE */ .h$.LINE, '"\n                ],\n                "potentialAction": {\n                  "@type": "SearchAction",\n                  "target": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_URL.WEB */ .h$.WEB, 'search?q={search_term_string}",\n                  "query-input": "required name=search_term_string"\n                }\n              }\n            ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                {\n                  "@context": "http://schema.org",\n                  "@type": "WebPage",\n                  "name": "lottery",\n                  "description": "'.concat((_article === null || _article === void 0 ? void 0 : _article.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_DESC */ .a0, '",\n                  "publisher": {\n                    "@type": "ProfilePage",\n                    "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_17__/* .WEB_NAME */ .Ey, '"\n                  }\n                }\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "http://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": [\n                  {\n                    "@type": "ListItem",\n                    "position": 1,\n                    "name": "หน้าแรก",\n                    "item": "'.concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_URL */ .FX, '"\n                  },\n                  {\n                    "@type": "ListItem",\n                    "position": 2,\n                    "name": "l",\n                    "item": "').concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_URL */ .FX, '/lottery"\n                  }\n                ]\n              }\n            ')
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layouts__WEBPACK_IMPORTED_MODULE_5__["default"], {
                sessionSevId: sessionSevId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "section-1",
                    className: "category-wrapper",
                    style: {
                        filter: src_constants__WEBPACK_IMPORTED_MODULE_16__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-lg-8 col-md-12",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_2_0_widgets_widget_breadcrumb__WEBPACK_IMPORTED_MODULE_15__["default"], {
                                            article: {
                                                section: {
                                                    th: "สลากกินแบ่งรัฐบาล",
                                                    en: "lottery"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "heading-title",
                                            children: "สลากกินแบ่งรัฐบาล"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                articles.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12 no-article",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_IMG */ .T, "/no-article.png"),
                                                        alt: "no-article",
                                                        width: "100%"
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_widgets_widget_lotto_result__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                                        }),
                                                        listArticles.map(function(item, index) {
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                id: index + 1,
                                                                className: "col-6 col-md-4 mb-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_card_v__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                    data: item,
                                                                    description: false,
                                                                    path: "/lottery/".concat(item.dateDefault),
                                                                    //! DATALAYER
                                                                    eventDataLayer: {
                                                                        type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                        section: "ข่าวทั้งหมด",
                                                                        position: "ใต้:header",
                                                                        data: {
                                                                            block: "1",
                                                                            title: item.title,
                                                                            heading: "สลากกินแบ่งรัฐบาล",
                                                                            index: index + 1
                                                                        }
                                                                    }
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                isFetching && "Fetching more list items..."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-lg-4 col-md-12 d-lg-block d-none",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_sticky_box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        offsetTop: 70,
                                        offsetBottom: 70,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_widgets_widget_lotto_check__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                //! DATALAYER
                                                eventDataLayer: {
                                                    type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                    section: "ตรวจผลสลากกินแบ่งรัฐบาล",
                                                    position: "ใต้:header"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "widget-content",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_2_0_widgets_widget_heading__WEBPACK_IMPORTED_MODULE_23__["default"], {
                                                        heading: "Latest News"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "block-content",
                                                        children: Array.isArray(lastNews) && lastNews.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "no-article",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                className: "--side",
                                                                src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_IMG */ .T, "/no-article.png"),
                                                                alt: "no-article",
                                                                width: "100%"
                                                            })
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                            className: "block-list",
                                                            children: lastNews.slice(0, 4).map(function(item, index) {
                                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_card_h__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                                        data: item,
                                                                        large: false,
                                                                        //! DATALAYER
                                                                        eventDataLayer: {
                                                                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                            section: "Latest News",
                                                                            position: "ใต้:ตรวจผลสลากกินแบ่งรัฐบาล",
                                                                            data: {
                                                                                block: "2",
                                                                                title: item.title,
                                                                                heading: "Latest News",
                                                                                index: index + 1
                                                                            }
                                                                        }
                                                                    })
                                                                }, index);
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageLottery);


/***/ }),

/***/ 36552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.breadcrumb {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    min-height: 40px;\n    li {\n      font-size: 16pt;\n      min-height: 30px;\n      &.more-cate {\n        a {\n          color: var(--primary-color);\n        }\n      }\n      color: var(--primary-color);\n    }\n    li + li {\n      &:before {\n        content: '>';\n        padding: 0 10px;\n        color: var(--primary-color);\n      }\n    }\n    @media (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function WidgetBreadcrumb(param) {
    var article = param.article;
    var ref, ref1, ref2, ref3;
    // console.log('article', article);
    var categoryName = ((ref = article.section) === null || ref === void 0 ? void 0 : ref.th) === "ข่าวล่าสุด" ? "Latest News" : (ref1 = article.section) === null || ref1 === void 0 ? void 0 : ref1.th;
    var subCategoryName = article.subCategory ? article.subCategory.th : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "breadcrumb",
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "/",
                    children: "หน้าแรก"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat(categoryName ? "/category/".concat(article === null || article === void 0 ? void 0 : (ref2 = article.section) === null || ref2 === void 0 ? void 0 : ref2.en) : ""),
                        children: categoryName
                    })
                ]
            }),
            subCategoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat("/category/".concat(article === null || article === void 0 ? void 0 : (ref3 = article.section) === null || ref3 === void 0 ? void 0 : ref3.en, "/").concat(article.subCategory.en)),
                        children: subCategoryName
                    }),
                    " "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetBreadcrumb);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].ul(_templateObject());


/***/ }),

/***/ 32668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ie": function() { return /* binding */ isShouldFetch; }
/* harmony export */ });
/* unused harmony exports getScrollElement, isSectionOne, isShouldFetchReadmore, calculateReadTime */

var getScrollElement = function(el) {
    var newEl = el;
    var elTop = newEl.offsetTop - newEl.offsetHeight * 3;
    while(newEl.offsetParent){
        newEl = newEl.offsetParent;
        elTop += newEl.offsetTop;
    }
    return elTop;
};
var isShouldFetch = function() {
    var footerEl = document.querySelector(".footer-wrapper");
    if (footerEl) {
        var scrollElement = getScrollElement(footerEl);
        return document.documentElement.scrollTop > scrollElement;
    }
    return false;
};
var isSectionOne = function() {
    var sectionEl = document.getElementById("section-1");
    if (sectionEl) {
        return true;
    }
    return false;
};
var isShouldFetchReadmore = function() {
    var footerEl = document.querySelector(".loadmore");
    if (footerEl) {
        var scrollElement = getScrollElement(footerEl);
        return document.documentElement.scrollTop + 700 > scrollElement;
    }
    return false;
};
function calculateReadTime(counter) {
    var toArray = function(num) {
        return num && _to_consumable_array("".concat(num)).map(function(elem) {
            return +elem;
        });
    };
    var _a = toArray(counter)[toArray(counter).length - 1] === 0 ? 0 : 1;
    var _b = counter - 1;
    var start = Math.floor((_a === 0 ? _b : counter) / 10) * 10;
    var end = Math.ceil(counter / 10) * 10;
    var first = start === 0 ? 1 : start + 1;
    var second = end === 0 ? 10 : end;
    return "".concat(first, "-").concat(second);
}


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GET; },
/* harmony export */   "M": function() { return /* binding */ GET_ARTICLES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);






// Service : GET ------------------------- */
function GET() {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    // If don't have data return [];
                    // If have data return [{ id: 1 }] or { data: [] }
                    // If can't call api return { data: null, msg: null }
                    // console.log(timestamp(), _url, ':');
                    if (!data.msg) {
                        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data.data)) {
                            return [
                                2,
                                all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data.data
                            ];
                        }
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat((0,_helper__WEBPACK_IMPORTED_MODULE_2__/* .timestamp */ .AB)(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET.apply(this, arguments);
}
function GET_ARTICLES() {
    return _GET_ARTICLES.apply(this, arguments);
}
function _GET_ARTICLES() {
    _GET_ARTICLES = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, _tmp2, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    if ((data === null || data === void 0 ? void 0 : data.statusCode) === 404) {
                        return [
                            2,
                            data
                        ];
                    } else if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data === null || data === void 0 ? void 0 : data.data)) {
                        return [
                            2,
                            all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data === null || data === void 0 ? void 0 : data.data
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp2, data) : []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat(new Date().toUTCString(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET_ARTICLES.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,2777,1033,7817,8764,9302,129,199,7241,9774,2888,179], function() { return __webpack_exec__(62320); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);